import { inject } from '@angular/core';
import { Router, Routes } from '@angular/router';

import { ROUTE_NAMES } from '@constants';
import { UserBeanService } from '@services';
import { i18nResolver, userBeanResolver } from 'src/app/core/resolvers';

export const signingRoutes: Routes = [
  {
    path: 'signingroom',
    title: 'WEB_BILLING_PROFILE_3',
    canActivate: [
      async ({ queryParams }) => {
        const router: Router = inject(Router);
        const userBean = await inject(UserBeanService).getUserBean();

        if (userBean.showSigningRoom) {
          return true;
        }

        return router.createUrlTree(['/home'], { queryParams });
      },
    ],
    resolve: {
      agorai18n: i18nResolver,
      userBean: userBeanResolver,
    },
    loadComponent: () =>
      import('../../shared/components/signing-room/signing-room.component').then(
        (m) => m.SigningRoomComponent
      ),
    data: { navigationRoute: ROUTE_NAMES.SIGNING_ROOM },
  },
];
